// removed by extract-text-webpack-plugin
module.exports = {"guidCard":"_-pages-PostTruck-compontents-GuideCard-guidCard","gcImg":"_-pages-PostTruck-compontents-GuideCard-gcImg","gcText":"_-pages-PostTruck-compontents-GuideCard-gcText","title":"_-pages-PostTruck-compontents-GuideCard-title","subTitle":"_-pages-PostTruck-compontents-GuideCard-subTitle","gcBtns":"_-pages-PostTruck-compontents-GuideCard-gcBtns","gcBtn":"_-pages-PostTruck-compontents-GuideCard-gcBtn","gcBtnPlus":"_-pages-PostTruck-compontents-GuideCard-gcBtnPlus"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PostTruck/compontents/GuideCard/style.css
// module id = 1878
// module chunks = 0